import { useQuery } from "@tanstack/react-query";
import i18next from "i18next";
import { getOrderNotes } from "../../api/apiOrders";

export const useGetOrderNotes = (id) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["order-notes", id, i18next.language],
        queryFn: () => getOrderNotes(id),
        enabled: !!id,
        retry: false,
    });

    return {
        notes: data?.data || [],
        isLoading,
        error,
        refetch,
    };
};
